import { render, staticRenderFns } from "./TopBar.vue.html?vue&type=template&id=35310aa4&scoped=true&lang=html&external"
import script from "./TopBar.vue.js?vue&type=script&lang=js&external"
export * from "./TopBar.vue.js?vue&type=script&lang=js&external"
import style0 from "./TopBar.vue.scss?vue&type=style&index=0&id=35310aa4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35310aa4",
  null
  
)

export default component.exports